import { buildProps } from '@xzx-design/utils'

import type { ExtractPropTypes } from 'vue-demi' // test vue-demi
import type Panel from './panel.vue'

export const panelProps = buildProps({
  title: {
    type: String,
    default: '',
  },
  br: {
    type: Boolean,
    default: true,
  },
  margin: {
    type: Boolean,
    default: false,
  },
})

export type PanelProps = ExtractPropTypes<typeof panelProps>
export type PanelInstance = InstanceType<typeof Panel>
